import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_arrow_up",
  "use": "icon-icon_arrow_up-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon_arrow_up\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M16 16H0V0h16z\" /><path fill=\"#BEBFCA\" fill-rule=\"nonzero\" d=\"m8 7.219-3.3 3.3-.943-.943L8 5.333l4.243 4.243-.943.943z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol